import Snappy from '../../../libs/snappy/snappy';
import { Accordion } from '../../accordion/scripts/accordion';
import $ from 'jquery';

Snappy.Component.AlternateDropdown = class AlternateDropdown extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-alternate-dropdown';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.accordion = this.element.querySelector('[data-cfa-accordion]').component;
        this.addListener();
        this.accordion.settings.time = 0;
    }

    addListener() {
        let body = document.querySelector('body');
        body.addEventListener('click', function (e) {
            let position = this.element.compareDocumentPosition(e.target);
            if (((position !== 0) && (position !== 20)) && (this.accordion.isOpened)) {
                this.accordion.close()
            }
        }.bind(this))
    }
};



// WEBPACK FOOTER //
// ./components/alternate-dropdown/scripts/alternate-dropdown.js